import Icon from "@/assets/images/logo_simbolo.png";

export const Logo = () => {
  let unidadeNome = "";
  try {
    const unidade = JSON.parse(localStorage.getItem("UnidadeLogada") as any);
    unidadeNome = unidade?.Nome || unidade?.nome || "";
  } catch {
    unidadeNome = "";
  }
  return (
    <>
      <div className="flex flex-col items-center mt-8">
        <div className="flex items-center gap-4">
          <img
            src={Icon}
            alt="Logo Academia das Especificas"
            className="flex justify-center items-center "
            width={32}
          />
          <span className="font-medium text-xl text-zinc-50">Matricula Web</span>
        </div>
        {unidadeNome && (
          <div className="mt-3 text-zinc-100 text-2xl font-bold text-center w-full">
            {unidadeNome}
          </div>
        )}
      </div>
      <h1 className="border-b mt-4"></h1>
    </>
  );
};
